  
import { sortByPriorityDesc } from "@/cms-services/consts";
import { ListDataSource } from "@/data/List/ListDataSource";
import { Vue, Component, Prop } from "vue-property-decorator";
import draggable from "vuedraggable";


@Component({
    components: {
        draggable,
    }
})
export default class Home extends Vue {
    @Prop() model:any
    loaded: boolean = false;
  

    dataSource: ListDataSource = new ListDataSource({
        config: {
            pageIndex: 1,
            pageSize: 1000,
        },
        className: "LeadClassParamItem",
    });

    mounted(){
        this.dataSource.items = this.model.items.sort(sortByPriorityDesc);
        this.loaded = false;
    }

    async remove(item:any){
        await this.dataSource.remove(item.id);
    }


    async add(){
        await this.dataSource.add({
            leadClassId:this.model.leadClassId,
            leadClassParamId:this.model.id,
            caption:"Значение " + this.dataSource.items.length,
            value:""
        })
    }
}
